import { lazy } from "react";
import type { Routes as RoutesType } from "../../types";
import { ROUTES } from "../../constants/routes";

export const protectedRoutes: RoutesType = [
  {
    key: "dashboard.home.index",
    path: ROUTES.DASHBOARD_ROUTE,
    component: lazy(() => import("../../pages/dashboard/home/index")),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.listings.dashboardListings",
    path: ROUTES.DASHBOARD_LISTINGS_ROUTE,
    component: lazy(
      () => import("../../pages/dashboard/listings/DashboardListings")
    ),
    roles: [3, 4],
  },
  {
    key: "dashboard.listings.myListings",
    path: ROUTES.MY_LISTINGS_ROUTE,
    component: lazy(() => import("../../pages/dashboard/listings/my-listings")),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.listings.newListings",
    path: ROUTES.NEW_LISTING_ROUTE,
    component: lazy(() => import("../../pages/dashboard/listings/newListing")),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.listings.editListingDetails",
    path: ROUTES.EDIT_LISTING_DETAILS_ROUTE,
    component: lazy(
      () => import("../../pages/dashboard/listings/edit-listing/[slug]")
    ),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.listings.listingsDetails",
    path: ROUTES.DASHBOARD_LISTING_DETAILS,
    component: lazy(() => import("../../pages/dashboard/listings/[slug]")),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.favorites",
    path: ROUTES.FAVORITES_ROUTE,
    component: lazy(() => import("../../pages/dashboard/favorites/index")),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.profile.completeProfile",
    path: ROUTES.COMPELETE_PROFILE_ROUTE,
    component: lazy(
      () => import("../../pages/dashboard/profile/compeleteProfile")
    ),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.profile.settings",
    path: ROUTES.SETTINGS_ROUTE,
    component: lazy(() => import("../../pages/dashboard/profile/settings")),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.profile.deleteProfile",
    path: ROUTES.DELETE_PROFILE,
    component: lazy(
      () => import("../../pages/dashboard/profile/deleteProfile")
    ),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.profile.preference",
    path: ROUTES.DELETE_PROFILE,
    component: lazy(() => import("../../pages/dashboard/profile/preference")),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.profile.changePassword",
    path: ROUTES.CHANGE_PASSWORD_ROUTE,
    component: lazy(
      () => import("../../pages/dashboard/profile/changePassword")
    ),
    roles: [1, 2, 3, 4],
  },
  {
    key: "dashboard.categories",
    path: ROUTES.CATEGORIES_ROUTE,
    component: lazy(() => import("../../pages/dashboard/categories")),
    roles: [3, 4],
  },
  {
    key: "subCategories",
    path: ROUTES.SUB_CATEGORIES_ROUTE,
    component: lazy(() => import("../../pages/dashboard/subCategories")),
    roles: [3, 4],
  },
  {
    key: "dashboard.users",
    path: ROUTES.DASHBOARD_USERS_ROUTE,
    component: lazy(() => import("../../pages/dashboard/users")),
    roles: [4],
  },
  {
    key: "dashboard.userDetails",
    path: ROUTES.DASHBOARD_USERS_DETAILS_ROUTE,
    component: lazy(() => import("../../pages/dashboard/users/[id]")),
    roles: [4],
  },
  {
    key: "dashboard.countries",
    path: ROUTES.DASHBOARD_COUNTRIES_ROUTE,
    component: lazy(() => import("../../pages/dashboard/countries/index")),
    roles: [3, 4],
  },
  {
    key: "dashboard.provinces",
    path: ROUTES.DASHBOARD_PROVINCES_ROUTE,
    component: lazy(() => import("../../pages/dashboard/provinces/index")),
    roles: [3, 4],
  },
  {
    key: "dashboard.articleCategory",
    path: ROUTES.DASHBOARD_ARTICLE_CATEGORY_ROUTE,
    component: lazy(
      () => import("../../pages/dashboard/articles/articleCategory")
    ),
    roles: [3, 4],
  },
  {
    key: "dashboard.articles",
    path: ROUTES.DASHBOARD_ARTICLES_ROUTE,
    component: lazy(() => import("../../pages/dashboard/articles/index")),
    roles: [3, 4],
  },
  {
    key: "dashboard.newArticles",
    path: ROUTES.DASHBOARD_NEW_ARTICLE_ROUTE,
    component: lazy(() => import("../../pages/dashboard/articles/newArticle")),
    roles: [3, 4],
  },
  {
    key: "dashboard.editArticles",
    path: ROUTES.DASHBOARD_EDIT_ARTICLE_ROUTE,
    component: lazy(() => import("../../pages/dashboard/articles/[id]")),
    roles: [3, 4],
  },
  {
    key: "dashboard.articleDetails",
    path: ROUTES.DASHBOARD_ARTICLE_DETAILS_ROUTE,
    component: lazy(
      () => import("../../pages/dashboard/articles/articleDetails")
    ),
    roles: [3, 4],
  },
  {
    key: "dashboard.ManageMessages",
    path: ROUTES.DASHBOARD_MESSAGES_ROUTE,
    component: lazy(() => import("../../pages/dashboard/messages.tsx")),
    roles: [1, 2, 3, 4],
  },
];
